import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setChannelsList } from ".";

export const useChannels = () => {
  const dispatch = useDispatch();
  const channelsState = useSelector((state) => state.channels);

  const handleChannelList = useCallback(
    (channels) => {
      return dispatch(setChannelsList(channels));
    },
    [dispatch],
  );

  // Computed value
  const isNotMonoActiveChannel = useSelector((state) => {
    const list = state.channels.channelList || [];
    const activeChannels = list.filter((item) => item.status === "ACTIVE");
    return activeChannels.length !== 1;
  });

  return {
    // State
    channelList: channelsState.channelList,

    // Computed values
    isNotMonoActiveChannel,

    // Actions
    setChannelList: handleChannelList,
  };
};
